var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "",
        visible: _vm.isOpen,
        width: "9rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "show-close": false,
        "custom-class": "success-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c("div", { staticClass: "sign-success" }, [
        _c("img", {
          attrs: { src: require("../../../assets/image/login/success.png") },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "sign-success_title" }, [
          _vm._v("You are verified!"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sign-success_tip" }, [
          _vm._v("Please add wells first, then mint Rep."),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "addbtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.close("add")
                },
              },
            },
            [_vm._v("Add Well")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "closebtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  return _vm.close("close")
                },
              },
            },
            [_vm._v("Skip")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }